// extracted by mini-css-extract-plugin
export default {"loginContainer":"form_loginContainer__UPtHt","containar_Input":"form_containar_Input__tUSue","input_fuera":"form_input_fuera__KDcrU","checkbox":"form_checkbox__uaUlt"};